import { bool, func } from 'prop-types';
import styled from 'styled-components';
import Button from '../StoraEnsoComponents/Button';

const Wrapper = styled.div`
  position: fixed;
  top: 80px; /* based on header height */
  left: 0;
  width: 100%;
  z-index: 999;
  display: flex;
  background-color: ${({theme}) => theme.colors.attention_bg};
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0.5rem;
  box-shadow: 0 0 20px rgb(34 36 38 / 15%);

  p {
    margin-bottom: 0;
  }

  ${Button} {
    margin-left: 2rem;
  }
`;

function NotificationUnsavedChanges({isOpen, onSave}) {

  return (
    isOpen ? (
      <Wrapper>
        <p>You have unsaved changes in this project.</p>
          <Button id="save_changes" size="sm" onClick={onSave}>Save changes</Button>
      </Wrapper>
    ) : null
  );
}

NotificationUnsavedChanges.propTypes = {
  isOpen: bool.isRequired,
  onSave: func.isRequired,
}

export default NotificationUnsavedChanges;